import api from "../axiosIntercepture";


export const createSalesOrder = async (payload) => {
    try {
        const response = await api.post("salesorder/create", payload);

        if (response.data?.success && response.data?.data) {
            return response.data.data;
        }

      
        const message = response.data?.message || "Failed to create SO";
        throw new Error(message);
    } catch (err) {
        console.error("Error creating SO:", err);

        let errorMessage = "Failed to create SO";
        if (err.response?.data?.message) {
            errorMessage = err.response.data.message;
        } else if (err.message) {
            errorMessage = err.message;
        }

    
        if (errorMessage.toLowerCase().includes("asn")) {
            errorMessage = `${errorMessage} — please ensure the ASN reference included in the payload is valid.`;
        }

        throw new Error(errorMessage);
    }
};


export const fetchSalesOrder = async (filters = {}, page, pageSize) => {
    try {

        const sendObj = {
            filters: filters,
            limit: pageSize,
            page: page + 1
        }

        const response = await api.post(`salesorder/fetch-multi-dynamic`, sendObj);

        if (!response.data?.success) {
            const msg = response.data?.message || "Failed to fetch SOs";
            throw new Error(msg);
        }

        // Always return array to simplify UI code
        return Array.isArray(response.data?.data?.data) ? response.data.data : [];
    } catch (err) {
        console.error("Error fetching SOs:", err);
        throw new Error(err?.response?.data?.message || "Failed to fetch SO/STOs");
    }
};

/**
 * POST /api/salesorder/refresh-wms
 * `Authorization` and `location_id` (selected warehouse) headers are set by the axios interceptor.
 */
export const refreshSalesOrderWms = async () => {
    try {
        const response = await api.post("salesorder/refresh-wms");
        if (response.data?.success === false) {
            throw new Error(response.data?.message || "Failed to sync Sales Orders with WMS");
        }
        return response?.data;
    } catch (err) {
        const message =
            err?.response?.data?.message ||
            err?.message ||
            "Failed to sync Sales Orders with WMS";
        throw new Error(message);
    }
};

// export const getSalesOrderById = async (id) => {
//     try {
//         const response = await api.post("salesorder/get", { id });

//         if (response.data?.success && response.data?.data) {
//             return response.data.data;
//         }
//         return null;
//     } catch (err) {
//         console.error("Error fetching SO/STO by id:", err);
//         throw new Error(err?.response?.data?.message || "Failed to fetch SO");
//     }
// };


export const getSalesOrderById = async (id) => {
    try {
        // Using axios params: POST /salesorder/fetch-list?id=...
        const response = await api.post(`salesorder/fetch-list?id=${id}`);

        const respData = response?.data;

        if (respData?.success && respData?.data != null) {
            const payload = respData.data;

            // If API returns an array, pick first item
            if (Array.isArray(payload)) {
                return payload.length ? payload[0] : null;
            }

            // Otherwise return object directly
            return payload;
        }

        return null;
    } catch (err) {
        console.error("Error fetching sales order by id:", err);
        const serverMsg = err?.response?.data?.message;
        throw new Error(serverMsg || "Failed to fetch sales order");
    }
};


export const updateSalesOrder = async (id, payload) => {
    if (!id) throw new Error("Missing id for updateSalesOrder");
    try {
        // using POST to the update/:id route as you specified (change to put if API expects PUT)
        const response = await api.post(`salesorder/update/${id}`, payload);

        if (response.data?.success && response.data?.data) {
            return response.data.data;
        }

        const message = response.data?.message || "Failed to update SO/STO";
        throw new Error(message);
    } catch (err) {
        console.error("Error updating SO/STO:", err);

        let errorMessage = "Failed to update SO/STO";
        if (err.response?.data?.message) {
            errorMessage = err.response.data.message;
        } else if (err.message) {
            errorMessage = err.message;
        }

        if (errorMessage.toLowerCase().includes("asn")) {
            errorMessage = `${errorMessage} — please ensure the ASN reference included in the payload is valid.`;
        }

        throw new Error(errorMessage);
    }
};
